import React from 'react'
import SeoFooter from './SeoHomepage.styles'

const SeoHomepage = ({ seoFooter }) => (
  <SeoFooter className='container'>
    <small data-test='homepage-seo-text' dangerouslySetInnerHTML={{ __html: seoFooter }} />
  </SeoFooter>
)

export default SeoHomepage
